<template>
	<div>
		<!-- <b-btn @click.prevent="$router.go(-1)" style="margin-left: 10px;">{{
			'Back' | translate
		}}</b-btn> -->

		<div class="margin-block"></div>

		<Franchise v-if="(role === 'master franchise' ||
				role === 'franchise' ||
				role === 'super franchise') &&
			!error
			"></Franchise>
		<Teacher v-if="role === 'teacher' && !error"></Teacher>
		<Parent v-if="role === 'parent' && !error"></Parent>
		<Student v-if="role === 'student' && !error"></Student>
		<div class="error" v-if="error">
			<h1 class="text-center">404</h1>
		</div>
	</div>
</template>

<script>
import Franchise from './Franchise.vue'
import Parent from './Parent.vue'
import Student from './Student.vue'
import Teacher from './Teacher.vue'

export default {
	name: 'profile',
	components: {
		Franchise,
		Parent,
		Teacher,
		Student,
	},
	data() {
		return {
			role: '',
			error: false,
		}
	},
	methods: {
		getUserInfo() {
			this.error = false
			this.axios({
				method: 'get',
				url: `users/user/${this.$route.params.id}`,
			})
				.then(response => {
					let profile = response.data
					profile.currency =
						profile.currency !== null
							? profile.currency.toUpperCase()
							: profile.currency
					profile.bonus_weeks =
						profile.bonus_weeks === null ? 0 : profile.bonus_weeks
					profile.bonus_days =
						profile.bonus_days === null ? 0 : profile.bonus_days

					if (profile.discounts.length === 0) {
						profile.discounts = 0
					} else {
						let discountArr = []
						profile.discounts.forEach(item => {
							discountArr.push(item.discount)
						})
						profile.discounts = discountArr.join(', ')
					}
					this.$store.commit('changeProfile', profile)
					this.role = response.data.role
				})
				.catch(e => {
					this.error = true
				})
		},
	},
	watch: {
		$route(from, to) {
			this.getUserInfo()
		},
	},
	created() {
		this.getUserInfo()
	},
}
</script>

<style scoped>
.margin-block {
	height: 50px;
}
</style>
